query LookupTravelerSearch($lookupName: String!, $first: Int) {
  lookupTravelerSearch(lookupName: $lookupName, first: $first,orderBy:_CREATED_DATE_DESC) {
    nodes {
      id
      _isUpdatable
      _isAliasInvoked
      _isAliasOriginalNameViewable
      _fullName
      _pickupAddress
      isEconomyClassPreferred
      isBusinessClassPreferred
      isFirstClassPreferred
      vendorNumber
      _isApproved
      department {
        name
      }
      userOccupation {
        userOccupationTitle
      }
      travelerAddressesByTravelerId(orderBy: IS_PRIMARY_DESC) {
        nodes {
          id
          _rowTimestamp
          addressLine1
          addressLine2
          cityName
          countryId
          stateRegionId
          postalCode
          telephoneNumber
          emailAddress
          isGroundTransferAddress
          isDeliveryAddress
          isPrimary
          stateRegion {
            stateRegion
            country {
              country
            }
          }
        }
      }

      travelPolicy {
        id
        isCompanion
        description
        isContractual
        isDefaultCustomizable
        companyCurrency {
          isoCode
        }
      }
      _travelPolicyAllowances(
        orderBy: TRAVEL_POLICY_EXPENDITURE_TYPE_BY_EXPENDITURE_TYPE_ID__SORT_ORDER_ASC
      ) {
        nodes {
          id
          expenditureType {
            expenditureType
          }
          allowanceOverrideAmount
          _allowanceDescription
          isAllowanceCustomizable
          _travelerPolicyAllowanceRowTimestamp
          _travelerPolicyAllowanceId
        }
      }
    }
  }
}
